import { ProcedureType } from "api/type";

export type TSelectOption = {
  procedure: ProcedureType;
  procedureImage: string;
};

export let procedureOptions: TSelectOption[] = [
  {
    procedure: ProcedureType.LIP_FILLER,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/lip_filler_icon.webp",
  },
  {
    procedure: ProcedureType.BREAST_AUGMENTATION,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/breast_augmentation_icon.webp",
  },
  {
    procedure: ProcedureType.BREAST_REDUCTION,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/breast_reduction_icon.webp",
  },
  {
    procedure: ProcedureType.BREAST_LIFT,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/breast_lift_icon.webp",
  },
  {
    procedure: ProcedureType.BREAST_LIFT_AND_AUGMENTATION,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/breast_augmentation_icon.webp",
  },
  {
    procedure: ProcedureType.BBL,
    procedureImage: "https://clinic-os.com/icons-plastic-surgery/bbl_icon.webp",
  },
  {
    procedure: ProcedureType.TUMMY_TUCK,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery%2Ftummy_tuck.png",
  },
  {
    procedure: ProcedureType.RHINOPLASTY,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/rhinoplasty_icon.webp",
  },
  {
    procedure: ProcedureType.OTOPLASTY,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/otoplasty_icon.webp",
  },
  {
    procedure: ProcedureType.FOREHEAD_LIFT,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/forehead_lift_icon.webp",
  },
  {
    procedure: ProcedureType.CHIN_SURGERY,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/chin_surgery_icon.webp",
  },
  {
    procedure: ProcedureType.LIPOSUCTION,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/liposuction_icon.webp",
  },
  {
    procedure: ProcedureType.BODY_LIFT,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/body_lift_icon.webp",
  },
  {
    procedure: ProcedureType.ARM_LIFT,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/arm_lift_icon.webp",
  },
  {
    procedure: ProcedureType.THIGH_LIFT,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/thigh_lift_icon.webp",
  },
  {
    procedure: ProcedureType.BOTOX_INJECTIONS,
    procedureImage:
      "https://clinic-os.com/icons-plastic-surgery/botox_injections_icon.webp",
  },
  // {
  //   procedure: ProcedureType.BURN_REPAIR,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.SCAR_REVISION,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.HAND_SURGERY,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.RECONSTRUCTIVE_SURGERY,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.HAIR_TRANSPLANTATION,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.DERMAL_FILLERS,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.LASER_TREATMENTS,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.CHEMICAL_PEEL,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.MICRODERMABRASION,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.LASER_HAIR_REMOVAL,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.BLEPHAROPLASTY,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.RHYTIDECTOMY,
  //   procedureImage: "",
  // },
  // {
  //   procedure: ProcedureType.CHEEK_AUGMENTATION,
  //   procedureImage: "",
  // },
];
